import crewStore from './store'

export default class CrewModule {
  name = 'crew'
  constructor({ store }) {
    store.registerModule(this.name, crewStore)
  }
}
